<template>
	<div class="exchange-item-container">
		<div class="exchange-item-row">
			<div class="exchange-item-wrapper"  v-for="(item,i) in itemList" :key="i" @click="showDetail(item)">
				<el-badge :value="item.applyCount" :max="99" class="item" :hidden="item.applyCount<1">
				<div class="exchange-item" v-if="!isApply">
					<div class="img-container">
						<img :src="item.img?item.img:defaultimg">
					</div>
					<div class="category" v-if="item.category !== '專卡'">
						{{item.category}}
					</div>	
					<div class="group" v-else>
						<span class="groupname">{{item.groupName}}</span>
						<span class="album">{{item.album}}</span>
					</div>			
					<div class="exchange-detail">
						<div class="own">
							<div class="member" v-for="(member) in item.ownMember" :key="member">{{member}} </div>
						</div>
						<div class="exchange-icon">換</div>
						<div class="target">
							<div class="member" v-for="(member,i) in item.targetMember" :key="i">{{member}} </div>
						</div>
					</div>
					<div class="note"><p><span v-for="(note) in item.note" :key="note">#{{note}} </span></p></div>
					<div class="user">
						<div class="user-info">
							<div class="img"><img src="../../../assets/user.jpg" alt=""></div>
							<div class="loginname">{{item.creator}}</div>
						</div>
						<div class="date">{{item.update_at}}</div>
					</div>
				</div>
				<div class="exchange-item" v-else>
					<div class="img-container">
						<img :src="item.exchangeInfo.img?item.exchangeInfo.img:defaultimg">
					</div>
					<div class="category" v-if="item.exchangeInfo.category !== '專卡'">
						{{item.exchangeInfo.category}}
					</div>	
					<div class="group" v-else>
						<span class="groupname">{{item.exchangeInfo.groupName}}</span>
						<span class="album">{{item.exchangeInfo.album}}</span>
					</div>			
					<div class="exchange-detail">
						<div class="own">
							<div class="member" v-for="(member) in item.exchangeInfo.ownMember" :key="member">{{member}} </div>
						</div>
						<div class="exchange-icon">換</div>
						<div class="target">
							<div class="member" v-for="(member,i) in item.exchangeInfo.targetMember" :key="i">{{member}} </div>
						</div>
					</div>
					<div class="note"><p><span v-for="(note) in item.exchangeInfo.note" :key="note">#{{note}} </span></p></div>
					<div class="user">
						<div class="user-info">
							<div class="img"><img src="../../../assets/user.jpg" alt=""></div>
							<div class="loginname">{{item.exchangeInfo.creator}}</div>
						</div>
						<div class="date">{{item.exchangeInfo.update_at}}</div>
					</div>
				</div>
				</el-badge>
			</div>
		</div>
		<exchangeDetail :showDialog.sync="showExchangeDetail" :exchangeItem ="curExchangeItem" @success="success"></exchangeDetail>
		<exchangeMessage :showDialog.sync="showExchangeMessage" :exchangeItem ="curExchangeItem"></exchangeMessage>
	</div>
</template>

<script>
import exchangeDetail from './exchangeDetail.vue'
import exchangeMessage from './exchangeMessage.vue'

export default {
	name:'exchangeItem',
	components:{
        exchangeDetail,
		exchangeMessage
    },
	props:{
		itemList:{
			type: Array,
			default: []
		},
		isApply:{
			type: Boolean,
			default: false,
		},
		isList:{
			type:Boolean,
			default:true
		}
	},
	data(){
		return {
			defaultimg:require('../../../assets/card1.jpg'),
			curExchangeItem:"",
			showExchangeDetail: false,
			showExchangeMessage: false,
		}
	},
	methods:{
		showDetail(item){
			if (this.isApply){
				this.curExchangeItem = item.exchangeInfo
			} else {
				this.curExchangeItem = item
			}
			if (this.isList){
				this.showExchangeDetail = true
			} else {
				this.showExchangeMessage = true
			}
			
		},
		success(){
			this.$emit('success')
		}
	}

}
</script>

<style lang="scss" scoped>
.exchange-item-container {
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
	padding: 42px 12px;
	box-sizing: border-box;
	.exchange-item-row {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.title {
		font-size: 24px;
		margin-bottom: 21px;
	}
	.exchange-item-wrapper{
		margin:27px;
		.exchange-item{
			position: relative;
			cursor: pointer;
			border-radius: 10px;
			width: 240px;
			.img-container{
				width: 100%;
				height: 200px;
				overflow: hidden;
				position: relative;
				border-radius: 10px;
			}
			img {
				width: 100%;
			}
			.category{
				display: inline-block;
				font-size: 12px;
				padding: 4px 8px;
				background-color: $mainColor;
				color: #fff;
				margin: 10px 0 ;
			}
			.group {
				display: inline-block;
				background-color: $mainColor;
				font-size: 12px;
				padding: 4px 8px;
				margin: 10px 0;
				.groupname {
					color: #fff;
					font-weight: 600;
					padding-right: 5px;
				}
				.album {
					color:$textColor;
					border-left: 1px solid #fff;
					padding-left: 5px;
				}
			}
			.exchange-detail {
				color: $titleColor;
				text-align: center;
				display: flex;
				align-items: center;
				box-sizing: border-box;
				.own,.target{
					display: flex;
					flex-wrap: wrap;
					font-size: 12px;
					.member {
						
					}
				}
				.own {
					font-size: 18px;
				}
				.exchange-icon{
					margin: 4px;
				}
			}
			.note {
				font-size: 12px;
				color: $textColor;
				margin: 10px 0;
			}
			.user {
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 12px;
				.user-info {
					display: flex;
					align-items: center;
				}
				.img{
					width: 20px;
					height: 20px;
					border-radius: 24px;
					position: relative;
					overflow: hidden;
					margin-right: 10px;
					img {
						width: 100%;
						position: absolute;
						top:50%;
						left: 50%;
						transform: translate(-50%,-50%);
					}
				}
				.loginname {
					color: $textColor;
				}
				.date {
					color: $textColor;
				}
			}
		}
	}
}

</style>